import { styled } from '@mui/material';
export const CenterWrapper = styled("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});